import React, { useState } from "react";
import "./Search.css";

const Search = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    if (searchTerm.trim()) {
      onSearch(searchTerm);
    }
  };

  return (
    <div className="search-container">
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="음식 이름을 입력하세요"
        className="search-input"
      />
      <button onClick={handleSearch} className="search-button">
        검색
      </button>
    </div>
  );
};

export default Search;